import React, { useState, useEffect, useRef } from 'react';
import { LabelField } from './AdditionalProcess.style';
import "bootstrap/dist/css/bootstrap.min.css";
import apis from '../../api';
import dateFormat from '../../services/DateFormat.service';
import invDateFormat from '../../services/InvertDateFormat.service';
import { Toast } from 'primereact/toast';
import { Dialog } from 'primereact/dialog';
import { Calendar } from 'primereact/calendar';
import { addLocale } from 'primereact/api';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import { ProgressBar } from 'primereact/progressbar';
import { saveAs } from 'file-saver';
import { Toolbar } from 'primereact/toolbar';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { InputText } from 'primereact/inputtext';
import '../../DataTableDemo.css';
import Video from '../Video/Video';
import { tableDate, timeToDate } from '../../services/tableDate.service';
import SkeletonTable from '../SkeletonTable/SkeletonTable';
import useWindowDimensions from '../hooks/useDimensions';
import "./AdditionalProcess.css"
import ConfBar from '../ConfBar/ConfBar';
import { Message } from 'primereact/message';
import { Card } from 'primereact/card';
import { InputTextarea } from 'primereact/inputtextarea';
import useParams from '../../helpers/useParams';
import useParamsAdditional from '../../helpers/useParamsAdditional';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { Avatar } from 'primereact/avatar';
import { excelReport } from '../../services/excelReport.service';
import { excelExport } from '../../services/excelExport.service';

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : AdditionalProcess
Description : Pagina de procesos adicionales
Date Autor Modification
================================================================================
06/10/2023 Santiago Coca - Pagina de procesos adicionales
================================================================================ */

export default function AdditionalProcess() {
  const toast = useRef(null);
  const [listaCalendario, setListaCalendario] = useState([]);
  const [calendarios, setCalendarios] = useState([]);
  const [calendario, setCalendario] = useState("");
  const [adicional, setAdicional] = useState("")
  const [contratoAdicional, setContratoAdicional] = useState("")
  const [observacion, setObservacion] = useState("")
  const [liquidacion, setLiquidacion] = useState("");
  const [contrato, setContrato] = useState("")
  const [plano, setPlano] = useState("")
  const [fechaPlano, setFechaPlano] = useState("")
  const [listaPlanoBancario, setListaPlanoBancario] = useState([])
  const [listaContratos, setListaContratos] = useState([])
  const [listaLiquidacion, setListaLiquidacion] = useState([])
  const [consultado, setConsultado] = useState(false)
  const [loading1, setLoading1] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [loading3, setLoading3] = useState(false);
  const [loading4, setLoading4] = useState(false);
  const [loading5, setLoading5] = useState(false);
  const [loading6, setLoading6] = useState(false);
  const [loading7, setLoading7] = useState(false);
  const [loading8, setLoading8] = useState(false);
  const [loading9, setLoading9] = useState(false);
  const [loading10, setLoading10] = useState(false);
  const [loading11, setLoading11] = useState(false);
  const [loading12, setLoading12] = useState(false);
  const [loadPage, setLoadPage] = useState(false)
  const [isOpen, setIsOpen] = React.useState(false);
  const [isOpenHistorico, setIsOpenHistorico] = React.useState(false);
  const [isOpenRN, setIsOpenRN] = React.useState(false);
  const [isOpenEliminar, setIsOpenEliminar] = React.useState(false);
  const [isOpenPlano, setIsOpenPlano] = React.useState(false);
  const [isOpenLiquidacion, setIsOpenLiquidacion] = React.useState(false);
  const [isOpenAsociar, setIsOpenAsociar] = React.useState(false);
  const [isOpenEliminarAsociar, setIsOpenEliminarAsociar] = React.useState(false);
  const [rowData, setRowData] = useState([]);
  const [first2, setFirst2] = useState(0);
  const [rows2, setRows2] = useState(5);
  const [selectedProducts, setSelectedProducts] = useState(null);
  const [filters1, setFilters1] = useState(null);
  const [globalFilterValue1, setGlobalFilterValue1] = useState('');

  const [rowDataLogs, setRowDataLogs] = useState([]);
  const [rowsLogs, setRowsLogs] = useState([]);
  const [first2Logs, setFirst2Logs] = useState(0);
  const [rows2Logs, setRows2Logs] = useState(10);
  const [selectedRowsLogs, setSelectedRowsLogs] = useState(null);
  const [filters1Logs, setFilters1Logs] = useState(null);

  const [rowDataAsociar, setRowDataAsociar] = useState([]);
  const [rowsAsociar, setRowsAsociar] = useState([]);
  const [first2Asociar, setFirst2Asociar] = useState(0);
  const [rows2Asociar, setRows2Asociar] = useState(10);
  const [selectedRowsAsociar, setSelectedRowsAsociar] = useState(null);
  const [filters1Asociar, setFilters1Asociar] = useState(null);

  const elementWidth = { width: "20rem" }
  const headers = { authorization: localStorage.getItem('token') }
  const { width } = useWindowDimensions()

  const [params] = useParams();
  const [paramsAdditional] = useParamsAdditional();
  const [nomina, setNomina] = useState([])
  const [historico, setHistorico] = useState([])

  const [rowsPlano, setRowsPlano] = useState([]);

  const [warningType, setWarningType] = useState("")

  const [warningRows, setWarningRows] = useState([]);
  const [warningFirst2, setWarningFirst2] = useState(0);
  const [warningRows2, setWarningRows2] = useState(10);

  const [errorRows, setErrorRows] = useState([])
  const [isOpenErrors, setIsOpenErrors] = useState(false)

  const [employees, setEmployees] = useState("")
  const [net, setNet] = useState("")

  useEffect(() => {
    /*Se inicializan las propiedades del reporte de nómina*/
    const payrollTemplate = async () => {
      if (localStorage.getItem('additional') === 'S') {
        let plantilla = []
        params.forEach((p, index) => {
          if (p.TAG === 'pinEntity' || p.TAG === 'pinClient') {
            plantilla.push({ NAME: p.OPTIONS[0].NAME, CODE: p.OPTIONS[0].CODE, LABEL: p.TAG, SHEET: p.SHEET_POSITION })
          }
          else {
            if (p.TAG === 'pinState') {
              plantilla.push({ NAME: "", CODE: "TODO", LABEL: p.TAG, SHEET: p.SHEET_POSITION })
            }
            else {
              plantilla.push({ NAME: "", CODE: "", LABEL: p.TAG, SHEET: p.SHEET_POSITION })
            }
          }
        })
        setNomina(plantilla)
      }
    }
    payrollTemplate()
  }, [params]);

  useEffect(() => {
    /*Se inicializan las propiedades del reporte de nómina*/
    const historicTemplate = async () => {
      if (localStorage.getItem('additional') === 'S') {
        let plantilla = []
        paramsAdditional.forEach((p, index) => {
          if (p.TAG === 'pinEntity' || p.TAG === 'pinClient') {
            plantilla.push({ NAME: p.OPTIONS[0].NAME, CODE: p.OPTIONS[0].CODE, LABEL: p.TAG, SHEET: p.SHEET_POSITION })
          }
          else {
            if (p.TAG === 'pivProcess') {
              plantilla.push({ NAME: "", CODE: "AD", LABEL: p.TAG, SHEET: p.SHEET_POSITION })
            }
            else {
              plantilla.push({ NAME: "", CODE: "", LABEL: p.TAG, SHEET: p.SHEET_POSITION })
            }
          }
        })
        setHistorico(plantilla)
      }
    }
    historicTemplate()
  }, [paramsAdditional]);

  useEffect(() => {
    const getTabla = async () => {
      if (localStorage.getItem('additional') === 'S') {
        setTabla()
      }
    }
    getTabla()
  }, []);

  addLocale('es', {
    firstDayOfWeek: 1,
    dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
    dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
    dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
    monthNames: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
    monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
    today: 'Hoy',
    clear: 'Claro'
  });

  const GetCalendar = async () => {
    try {
      await apis.getPeriodicAdditionalCalendar(localStorage.getItem('entity'), localStorage.getItem('client'), headers).then(res => {
        const lista = res.data["CALENDARS"]
        setListaCalendario(lista)
      })
    }
    catch (err) {
      toast.current.show({ severity: 'warn', summary: 'Alerta', detail: err.response.data.message, sticky: true });
    }
  }

  let intervalId

  const interval = () => {
    intervalId = !intervalId && setInterval(() => {
      console.log(liquidacion)
      setWarningTable()
    }, 60000)

    if (!liquidacion) {
      console.log("Se cierra")
      clearInterval(intervalId);
    }
  }

  useEffect(() => {
    interval()
    return () => clearInterval(intervalId)
  }, [liquidacion])


  async function setTabla() {
    await apis.getAdditionalCalendar(localStorage.getItem('entity'), localStorage.getItem('client'), "AD", headers).then(res => {
      if (res.data["CALENDARS"].length > 0) {
        const contenidoTabla = res.data["CALENDARS"]
        let contenido = []
        contenidoTabla.forEach(c => {
          let fila = c
          let estado = fila.STATUS.split('|')
          fila = {
            ...fila,
            STATUS: estado[1],
            STATUS_ID: estado[0]
          }
          contenido.push(fila)
        })
        setRowData(contenido)
      } else {
        setRowData([])
      }
      setLoadPage(true)
    }).catch(err => {
      setLoadPage(true)
      toast.current.show({ severity: 'warn', summary: 'Alerta', detail: err.response.data.message, sticky: true });
    })
  }

  async function setTablaAsociar(calendario) {
    const _calendario = calendario
    await apis.getAdditionalEmployees(localStorage.getItem('entity'), localStorage.getItem('client'), _calendario, headers).then(res => {
      const contratos = res.data['CONTRACTS']
      setRowsAsociar(contratos)
    }).catch(err => {
      setLoadPage(true)
      toast.current.show({ severity: 'warn', summary: 'Alerta', detail: err.response.data.message, sticky: true });
    })
  }

  const getAdditionalList = async (adicional) => {
    const _entity = localStorage.getItem('entity')
    const _client = localStorage.getItem('client')
    const _adicional = adicional

    try {
      await apis.getListNovAdditional(_entity, _client, _adicional, headers).then(res => {
        const contratos = res.data['CONTRACTS']
        setListaContratos(contratos)
      })
    }
    catch (err) {
      setListaContratos([])
      toast.current.show({ severity: 'warn', summary: 'Alerta', detail: err.response.data.message, sticky: true });
    }
  }

  const showModal = () => {
    GetCalendar()
    setIsOpen(true);
  };

  const hideModal = () => {
    limpiar()
    setIsOpen(false);
  };

  const showModalHistorico = () => {
    setIsOpenHistorico(true);
  };

  const hideModalHistorico = () => {
    setIsOpenHistorico(false);
  };

  const showModalEliminar = (adicional) => {
    setAdicional(adicional)
    setIsOpenEliminar(true);
  };

  const showModalEliminarAsociar = (adicional) => {
    setContratoAdicional(adicional)
    setIsOpenEliminarAsociar(true);
  };

  const hideModalEliminar = () => {
    setIsOpenEliminar(false)
  };

  const hideModalEliminarAsociar = () => {
    setIsOpenEliminarAsociar(false)
  };


  const showModalPlano = () => {
    // calendarioPlano(rowData)
    setIsOpenPlano(true);
  };

  const hideModalPlano = () => {
    setIsOpenPlano(false)
    setPlano('')
    setListaPlanoBancario([])
    setRowsPlano([])
    setFechaPlano('')
  };

  const showModalLiquidacion = (rowData) => {
    calendarioLiquidacion(rowData)
    setIsOpenLiquidacion(true);
  };

  const hideModalLiquidacion = () => {
    setRowDataLogs([])
    setConsultado(false)
    setLiquidacion("")
    setIsOpenLiquidacion(false)
    setLoading5(false)
    setLoading6(false)
    setLoading7(false)
  };

  const showModalRN = () => {
    setIsOpenRN(true);
  };

  const hideModalRN = () => {
    setIsOpenRN(false);
  };

  const showModalAsociar = (calendario, adicional) => {
    setAdicional(adicional)
    setCalendario(calendario)
    getAdditionalList(adicional)
    setTablaAsociar(calendario)
    setIsOpenAsociar(true);
  };

  const hideModalAsociar = () => {
    setRowsAsociar([])
    setIsOpenAsociar(false);
  };

  function inizilaizarData(rowData) {
    setCalendario(rowData.ID_CALENDAR)
  }

  async function limpiar() {
    setCalendario("");
    setObservacion("")
  }

  const setWarningTable = async () => {
    const _calendario = liquidacion.ID_CALENDAR
    try {
      await apis.getWarning(localStorage.getItem('entity'), localStorage.getItem('client'), _calendario, headers).then(res => {
        let data = res.data.WARNING
        console.log(data)
        if (data.length > 0) {
          let newData = []
          data.forEach(row => {
            let newRow = {
              CONTRACT: row.LABEL.split(':')[1],
              ...row
            }
            newData.push(newRow)
          })
          setWarningRows(newData)
        }
        else {
          setWarningRows([])
        }
        setWarningType(res.data.STATUS)
        setTablaLogs()
      })
    }
    catch (err) {
      let msg = err.response
      toast.current.show({ severity: 'warn', summary: 'Aviso', detail: msg, sticky: true });
    }
  }

  async function completarRegistro() {

    setLoading1(true)
    const _cliente = localStorage.getItem('client')
    const _entity = localStorage.getItem('entity')
    const _calendario = calendario.ID_CALENDAR;
    // const _observacion = observacion

    const payload = {
      CLIENT: _cliente,
      ENTITY: _entity,
      ID_CALENDAR: _calendario,
      LOV_PROCESS: 'AD',
      // OBSERVATION: _observacion
    }

    await apis.postAdditionalCalendar(payload, headers).then(res => {
      toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Calendario agregado exitosamente', life: 4000 });
      hideModal();
      setTabla();
      limpiar();
      setLoading1(false)
    }).catch(err => {
      toast.current.show({ severity: 'warn', summary: 'Alerta', detail: err.response.data.message.split("\""), sticky: true });
      setLoading1(false)
    })

  }

  async function eliminar() {

    setLoading2(true)
    const _cliente = localStorage.getItem('client');
    const _entity = localStorage.getItem('entity')
    const _adicional = adicional;

    try {
      await apis.deleteAdditionalCalendar(_entity, _cliente, _adicional, headers).then(res => {
        toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Calendario eliminado exitosamente', life: 4000 });
        setLoading2(false)
        setTabla();
        hideModalEliminar()
      })
    }
    catch (err) {
      toast.current.show({ severity: 'warn', summary: 'Alerta', detail: err.response.data.message.split("\""), sticky: true });
      setLoading2(false)
    }
  }

  async function eliminarAsociar() {

    setLoading10(true)
    const _cliente = localStorage.getItem('client');
    const _entity = localStorage.getItem('entity')
    const _contratoAdicional = contratoAdicional;

    try {
      await apis.deleteAdditionalEmployees(_entity, _cliente, _contratoAdicional, headers).then(res => {
        toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Contrato asociado eliminado exitosamente', life: 4000 });
        setLoading10(false)
        setTablaAsociar(calendario);
        getAdditionalList(adicional);
        hideModalEliminarAsociar()
      })
    }
    catch (err) {
      toast.current.show({ severity: 'warn', summary: 'Alerta', detail: err.response.data.message.split("\""), sticky: true });
      setLoading10(false)
    }
  }

  async function calendarioPlano(rowData) {
    let _calendario = rowData.ID_CALENDAR.split("|")
    let param = localStorage.getItem("client") + "-LD-" + _calendario[0]
    let _entity = localStorage.getItem('entity')
    try {
      await apis.getLastCalendar(_entity, param, headers).then(res => {
        let contenido = res.data.CALENDAR
        console.log(contenido)
        setListaPlanoBancario(contenido)
      })
    }
    catch (err) {
      toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true })
    }
  }

  async function calendarioLiquidacion(rowData) {
    let _calendario = rowData.ID_CALENDAR
    let param = "AD-" + _calendario
    try {
      await apis.getValueListCalendar(param, headers).then(res => {
        let contenido = res.data.CALENDAR
        let calendar = contenido[0]
        setLiquidacion(calendar)
        setListaLiquidacion(contenido)
      })
    }
    catch (err) {
      toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true })
    }
  }

  async function setTablaLogs() {
    /*Función encargada de cargar la  información de la tabla de procesos */
    const _calendario = liquidacion.ID_CALENDAR
    try {
      await apis.getExecutedProcess(localStorage.getItem('entity'), _calendario, localStorage.getItem('client'), "NULL", headers).then(res => {
        if (res.data["PROCESS"].length > 0) {
          let data = res.data["PROCESS"]
          setRowsLogs(data)
          setRowDataLogs(data)
          setEmployees(res.data.TOTAL_CONTRACT)
          setNet(res.data.TOTAL_REMUNER)
          setConsultado(true)
        }
        else {
          setRowsLogs([])
          setRowDataLogs([])
          setEmployees("")
          setNet("")
        }
        setLoading9(false)
        setLoading11(false)
      })
    }
    catch (err) {
      setLoading9(false)
      setLoading11(false)
    }
  }

  async function postPayrollReport() {
    /*Función encargada de cargar la informacion del reporte de nómina*/
    let finalReport = []
    const client = localStorage.getItem('client')
    const _entity = localStorage.getItem('entity')
    const _calendario = calendario
    const option = "1"
    let report = {
      CLIENT: client,
      ENTITY: _entity,
      OPTION: option,
      REPORTS: []
    }
    let max = 0
    nomina.forEach(n => {
      let size = n.SHEET.length
      if (size > max) {
        max = size
      }
    })
    for (let i = 0; i < max; i++) {
      report.REPORTS.push({ PARAMETERS: [] })
    }

    nomina.forEach(n => {
      n.SHEET.forEach(e => {
        if (n.LABEL === 'pinCalendar') {
          report.REPORTS[e].PARAMETERS.push({ LABEL: n.LABEL, VALUE: _calendario })
        }
        else {
          report.REPORTS[e].PARAMETERS.push({ LABEL: n.LABEL, VALUE: n.CODE })
        }
      })
    })
    try {
      await apis.postReportPayroll(report, headers).then(res => {
        finalReport = res.data
        excelReport(finalReport, "reporteNomina")
        setLoading3(false)
        toast.current.show({ severity: 'success', summary: 'Éxito', detail: "Reporte de nómina generado existosamente" });
        hideModalRN();
      })
    }
    catch (err) {
      setLoading3(false)
      toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
    }
  }

  async function postHistorico() {
    /*Función encargada de cargar la informacion del reporte de nómina*/
    let finalReport = []
    const client = localStorage.getItem('client')
    const _entity = localStorage.getItem('entity')
    // const _calendario = calendario
    const option = "1"
    let report = {
      CLIENT: client,
      ENTITY: _entity,
      OPTION: option,
      REPORTS: []
    }
    let max = 0

    historico.forEach(n => {
      let size = n.SHEET.length
      if (size > max) {
        max = size
      }
    })
    for (let i = 0; i < max; i++) {
      report.REPORTS.push({ PARAMETERS: [] })
    }
    historico.forEach(n => {
      n.SHEET.forEach(e => {
        report.REPORTS[e].PARAMETERS.push({ LABEL: n.LABEL, VALUE: n.CODE })
      })
    })
    try {
      await apis.postAdditionalReport(report, headers).then(res => {
        finalReport = res.data
        excelReport(finalReport, "historicoAdicionales")
        setLoading12(false)
        toast.current.show({ severity: 'success', summary: 'Éxito', detail: "Reporte de nómina generado existosamente" });
        hideModalHistorico();
      })
    }
    catch (err) {
      setLoading12(false)
      toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
    }
  }

  function exportWarningTable() {
    let newData = []
    warningRows.forEach(warn => {
      let newWarn = {
        Contrato: warn.CONTRACT,
        Comentario: warn.OBSERVATION
      }
      newData.push(newWarn)
    })
    excelExport(newData, "Warnings")
  }

  const showConfirm = (id, process) => {
    /*Función encargada de mostrar al usuario un mensaje de confirmación de la realización de un proceso*/
    toast.current.show({
      severity: 'success', content: (
        <div className="flex flex-column" style={{ flex: '1' }}>
          <div className="text-center">
            <i className="pi pi-check-circle" style={{ fontSize: '3rem', color: "green" }}></i>
            <p>Proceso {process}({id}) realizado existosamente</p>
          </div>
        </div>
      )
    });
  }

  async function processes(action) {
    /*Función encargada de validar cuál proceso se desea realizar*/
    const _cliente = localStorage.getItem('client')
    const _entity = localStorage.getItem('entity')
    const _calendario = liquidacion
    const p = {
      ID_CALENDAR: _calendario.ID_CALENDAR,
      CLIENT: _cliente,
      ENTITY: _entity,
      ACTION: action
    }
    let msg = ""
    if (action == "PRO") {
      msg = "Procesar"
    }
    else {
      if (action == "CLO") {
        msg = "Acumular"
      }
      else {
        if (action == "REV") {
          msg = "Deshacer"
        }
      }
    }
    try {
      await apis.executeProcess(p, headers).then(res => {
        console.log(_calendario)
        setLiquidacion(_calendario)
      })
      setTimeout(() => {
        apis.getExecutedProcess(_entity, _calendario.ID_CALENDAR, _cliente, action, headers).then(res => {
          if (res.data.PROCESS.length > 0) {
            let data = res.data.PROCESS[0]
            console.log(data)
            if (data !== "") {
              let id = data.ID
              showConfirm(id, msg)
            }
            setLoading5(false)
            setLoading6(false)
            setLoading7(false)
          }
          else {
            setLoading5(false)
            setLoading6(false)
            setLoading7(false)
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: "No hay registros para el proceso", sticky: true });
          }
        })
        setWarningTable()
        setTabla()
      }, 1000)
    }
    catch (err) {
      msg = err.response.data.message
      setLoading5(false)
      setLoading6(false)
      setLoading7(false)
      toast.current.show({ severity: 'warn', summary: 'Aviso', detail: msg, sticky: true });
    }
  }

  async function bankFlat() {
    /*Función encargada de gnerar el archivo txt de plano bancario*/
    const client = localStorage.getItem('client')
    const entity = localStorage.getItem('entity')
    const date_pay = dateFormat(fechaPlano)
    const id_last_calendar = calendario
    try {
      await apis.getBankFlat(entity, client, date_pay, id_last_calendar, headers).then(res => {
        let contenido = res.data["FLAT_FILES"]
        let planos = []
        contenido.forEach(file => {
          if (file["DETAIL"].length > 0) {
            let nombre = file.NAME
            let contratos = file.TOTAL_CONTRACT
            let total = file.TOTAL_VALUE
            let lineas = ""
            file["DETAIL"].forEach(element =>
              lineas += element.LINE + "\r\n"
            )
            planos.push({
              nombre,
              contratos,
              total,
              lineas
            })
          }
        })
        setRowsPlano(planos)
        setLoading4(false)
        toast.current.show({ severity: 'success', summary: 'Éxito', detail: "Plano(s) bancario(s) generado exitosamente" });
        // // hideModalPlano()
        // const blob = new Blob([lineas], { type: 'text/plain;charset=utf-8;', endings: "transparent" });
        // saveAs(blob, nombre);
      })
    }
    catch (err) {
      setLoading4(false)
      toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
    }
  }

  const flatDetail = (flat) => {
    const blob = new Blob([flat.lineas], { type: 'text/plain;charset=utf-8;', endings: "transparent" });
    saveAs(blob, flat.nombre);
  }

  const postAdditionalEmployees = async () => {
    setLoading8(true)
    const payload = {
      ENTITY: localStorage.getItem('entity'),
      CLIENT: localStorage.getItem('client'),
      ID_CALENDAR: calendario,
      CONTRACT_ID: contrato.CODE
    }

    try {
      await apis.postAdditionalEmployees(payload, headers).then(res => {
        toast.current.show({ severity: 'success', summary: 'Éxito', detail: "Empleado asociado existosamente" });
        setLoading8(false)
      })
      setContrato("")
      getAdditionalList(adicional);
      setTablaAsociar(calendario)
    }
    catch (err) {
      setLoading8(false)
      toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
    }
  }

  //Evento para cambiar de pagina
  const onCustomPage2 = (event) => {
    setFirst2(event.first);
    setRows2(event.rows);
  }
  //Retorna componente del paginador de la tabla y se puede configurar el numero de elementos por pagina
  const template2 = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        { label: 5, value: 5 },
        { label: 10, value: 10 },
        { label: 20, value: 20 }
      ];

      return (
        <React.Fragment>
          <span className="mx-1" style={{ color: 'var(--text-color)', userSelect: 'none' }}>Elementos por pagina: </span>
          <Dropdown value={options.value} options={dropdownOptions} onChange={options.onChange} />
        </React.Fragment>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{ color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center' }}>
          {options.first} - {options.last} of {options.totalRecords}
        </span>
      )
    }
  };

  //Boton Agregar Persona izquierda de la tabla
  const centerToolbarTemplate = () => {
    return (
      <React.Fragment>
        <Button label="Nuevo calendario" icon="pi pi-calendar" className="p-button-primary mr-2 p-button-sm" onClick={showModal} />
      </React.Fragment>
    )
  }

  //Boton Agregar Persona izquierda de la tabla
  const leftToolbarTemplate = () => {
    return (
      <React.Fragment>
        <Button label="Histórico" icon="pi pi-file-excel" className="p-button-success mr-2 p-button-sm" onClick={showModalHistorico} />
      </React.Fragment>
    )
  }

  //Boton editar persona de la tabla, en rowData se guarda el {} con todos los datos de la fila
  const actionBodyTemplate = (rowData) => {
    return (
      <div className="flex">
        <Button icon="pi pi-trash" className="p-button-danger  p-button-sm text-xs mr-2" onClick={() => { showModalEliminar(rowData.ID_ADDITIONAL) }} />
        <Button icon="pi pi-plus" tooltip='Asociar contrato' tooltipOptions={{ position: 'top' }} className="p-button-success p-button-sm text-xs mr-2" onClick={() => { showModalAsociar(rowData.ID_CALENDAR, rowData.ID_ADDITIONAL); }} />
        <Button label="Liquidar" className="p-button-sm text-xs mr-2" onClick={() => { inizilaizarData(rowData); showModalLiquidacion(rowData) }} />
        <Button label="Plano" className="p-button-sm text-xs mr-2" onClick={() => { inizilaizarData(rowData); showModalPlano() }} />
        <Button label="Reporte" className="p-button-sm text-xs" onClick={() => { inizilaizarData(rowData); showModalRN() }} />
      </div>
    )
  }

  const totalBodyTemplatePlano = (rowData) => {
    return formatCurrency(rowData.total);
  }

  const netBodyTemplatePlano = (rowData) => {
    if(rowData.TOTAL_REMUNER){
      return formatCurrency(rowData.TOTAL_REMUNER);
    }
    return rowData.TOTAL_REMUNER;
  }

  const actionBodyTemplatePlano = (rowData) => {
    return (
      <Button icon="pi pi-download" className="p-button-info mr-2 p-button-sm text-xs" tooltip="Comprobante" tooltipOptions={{ position: 'top' }}
        onClick={() => {
          flatDetail(rowData)
        }} />
    )
  }

  const actionBodyTemplateAsociar = (rowData) => {
    return (
      <div className="flex">
        <Button icon="pi pi-trash" className="p-button-danger  p-button-sm text-xs mr-2" onClick={() => { showModalEliminarAsociar(rowData.CONTRACT_ADIC_ID) }} />
      </div>
    )
  }

  //Componente Header donde se encuetra el textLabel para el filtrado global y el boton de limpiar filtro
  const renderHeader1 = () => {
    return (
      <div className="barra">
        <Button type="button" icon="pi pi-filter-slash" label="Limpiar filtros" className="p-button-outlined p-button-sm" onClick={clearFilter1} />
        <IconField iconPosition="left">
          <InputIcon className="pi pi-search"> </InputIcon>
          <InputText value={globalFilterValue1} onChange={onGlobalFilterChange1} placeholder="Palabra clave" className="p-inputtext-sm"
            style={{
              width: "100%"
            }}
          />
        </IconField>
      </div>
    )
  }

  //Función para encasular valor del filtro global y buscar con el filtro FilterMatchMode.CONTAINS
  const onGlobalFilterChange1 = (e) => {
    const value = e.target.value;
    let _filters1 = {
      'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
    };
    _filters1['global'].value = value;
    setFilters1(_filters1);
    setGlobalFilterValue1(value);
  }

  //Limpiar e inicializar los filtros
  const clearFilter1 = () => {
    initFilters1();
  }

  //Constante para insertar componente Header en la parte superior de la tabla donde se ubica el textLabel para el filtrado global
  const header1 = renderHeader1();

  //Limpiar filtros de la tabla
  const initFilters1 = () => {
    setFilters1({
      'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
      'CONTRACT_ID': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'NUMBER_ID': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'NAME': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'END_DATE': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'LOV_REASON': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'STATUS': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] }
    });
    setGlobalFilterValue1('');
  }

  //Nombre de las opciciones para los filtros
  const matchModes = [
    { label: 'COMIENZA CON', value: FilterMatchMode.STARTS_WITH },
    { label: 'CONTIENE', value: FilterMatchMode.CONTAINS },
    { label: 'NO CONTIENE', value: FilterMatchMode.NOT_CONTAINS },
    { label: 'TERMINA CON', value: FilterMatchMode.ENDS_WITH },
    { label: 'IGUAL A', value: FilterMatchMode.EQUALS },
    { label: 'DIFERENTE A', value: FilterMatchMode.NOT_EQUALS }
  ];



  const addFooter = (
    <div>
      <Button onClick={hideModal}>Cancelar</Button>
      <Button onClick={completarRegistro} loading={loading1} label='Guardar'></Button>
    </div>
  );

  const addHeader = (
    <div>
      <h3>Agregar calendario</h3>
    </div>
  );

  const hisotricoFooter = (
    <div>
      <Button label="Generar" loading={loading12} onClick={() => { setLoading12(true); postHistorico() }} />
    </div>
  );

  const historicoHeader = (
    <div>
      <h3>Histórico procesos adicionales</h3>
    </div>
  );

  const deleteFooter = (
    <div>
      <Button onClick={hideModalEliminar}>Cancelar</Button>
      <Button onClick={eliminar} loading={loading2} label='Si'></Button>
    </div>
  );

  const deleteHeader = (
    <div>
      <h3>¿Desea eliminar el proceso adicional?</h3>
    </div>
  );

  const deleteFooterAsociar = (
    <div>
      <Button onClick={hideModalEliminarAsociar}>Cancelar</Button>
      <Button onClick={eliminarAsociar} loading={loading10} label='Si'></Button>
    </div>
  );

  const deleteHeaderAsociar = (
    <div>
      <h3>¿Desea eliminar el contrato asociado?</h3>
    </div>
  );

  const footerPB = (
    <div>
      <Button label="Generar" loading={loading4} onClick={() => { setLoading4(true); bankFlat() }} disabled={calendario === "" || !fechaPlano} />
      {rowsPlano.length > 0 && <DataTable className="text-xs" value={rowsPlano} paginator paginatorTemplate={template2} first={first2} rows={rows2} onPage={onCustomPage2}
        dataKey="ID" size="small">
        <Column selectionMode="single" headerStyle={{ width: '3em' }}></Column>
        <Column field="nombre" headerStyle={{ width: '12rem', textAlign: 'center' }} header="Nombre"></Column>
        <Column field="contratos" headerStyle={{ width: '12rem', textAlign: 'center' }} header="Total contratos"></Column>
        <Column field="total" headerStyle={{ width: '12rem', textAlign: 'center' }} header="Valor" body={totalBodyTemplatePlano}></Column>
        <Column header="Documento" headerStyle={{ width: '12rem', textAlign: 'center' }} body={actionBodyTemplatePlano}></Column>
      </DataTable>}
    </div>
  );

  const headerPB = (
    <div>
      <h3>Seleccionar fecha de pago para liquidación plano bancario</h3>
    </div>
  )

  const formatCurrency = (value) => {
    let currency = parseFloat(value)
    return currency.toLocaleString('es-CO', { style: 'currency', currency: 'COP' });
  };

  const tableHeader = (
    <div className="table-header flex justify-content-between">
      <div className="flex align-items-center flex-row">
        <i className="pi pi-users mr-2" style={{ fontSize: '1.5rem' }}></i>
        <div className="flex align-items-start flex-column">
            <span className="m-0">Número empleados: {employees}</span>
            <span className="m-0">Neto: {net ? formatCurrency(net) : net}</span>
        </div>
      </div>
      <Button icon="pi pi-refresh" loading={loading9} tooltip="Refrescar tabla" tooltipOptions={{ position: 'top' }} className="p-button-succcess mr-2 p-button-sm"
        onClick={() => { setLoading9(true); setWarningTable() }} disabled={(loading5 || loading6 || loading7)} />
    </div>
  );

  const tableHeader2 = (
    <div className="table-header flex justify-content-between">
      <Avatar icon={warningType === "RUNNING" ? "pi pi-spin pi-spinner-dotted" : "pi pi-exclamation-triangle"} size="large"
        style={{ backgroundColor: warningType === "RUNNING" ? '#2196F3' : 'red', color: '#ffffff' }} shape="circle" />
      <Button icon="pi pi-file-excel" label="Exportar" className="p-button-success mr-2 p-button-sm" onClick={() => { exportWarningTable() }} />
    </div>
  );

  const rowClassName = (rowData) => {
    return { 'error-row': (rowData["STATUS"] === "ERROR") };
  }

  const percentageBodyTemplate = (rowData) => {
    return <ProgressBar value={rowData.PERCENTAGE}></ProgressBar>;
  }

  const endDateTemplate = (rowData) => {
    const date = timeToDate(rowData.END_DATE);
    return date
  }

  const actionBodyTemplateErrors = (rowData) => {
    console.log(rowData.ERRORS)
    return (
      <div>
        {rowData.ERRORS && <Button icon="pi pi-search" className="p-button-info mr-2 p-button-sm text-xs" tooltip="Visualizar errores" tooltipOptions={{ position: 'top' }} onClick={() => { setErrorRows(rowData.ERRORS); setIsOpenErrors(true) }} />}
      </div>
    )
  }

  const footerLN = (
    <>
      <div>
        <Button label="Procesar" style={{ marginLeft: "-1rem" }} loading={loading5} onClick={() => { setLoading5(true); processes("PRO") }} disabled={!liquidacion || listaLiquidacion.length === 0 || (loading5 || loading6 || loading7)} />
        <Button label="Acumular" loading={loading6} onClick={() => { setLoading6(true); processes("CLO") }} disabled={!liquidacion || listaLiquidacion.length === 0 ||  (loading5 || loading6 || loading7)} />
        <Button label="Deshacer" loading={loading7} onClick={() => { setLoading7(true); processes("REV") }} disabled={!liquidacion || listaLiquidacion.length === 0 ||  (loading5 || loading6 || loading7)} />
      </div>
      {
        consultado === true ?
          <div className="datatable-style-demo">
            <DataTable className="text-xs" header={tableHeader} value={rowsLogs} first={first2Logs} rows={rows2Logs} onPage={onCustomPage2}
              selection={selectedRowsLogs} onSelectionChange={(e) => setSelectedRowsLogs(e.value)} dataKey="ID"
              size="small" filters={filters1Logs} filterDisplay="menu" globalFilterFields={['ID', 'TRHEAD', 'JOB', 'RECORD', 'START', 'END', 'PROCESSED', 'ERROR', 'PERCENTAGE', 'ACTION', 'STATUS']}
              rowClassName={rowClassName}
            >
              <Column showFilterOperator={false} filterMatchModeOptions={matchModes} body={actionBodyTemplateErrors}></Column>
              <Column field="ID" header="ID" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por ID" sortable></Column>
              <Column field="STATUS" header="Estado" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Estado" sortable></Column>
              <Column field="PERCENTAGE" header="Porcentaje" body={percentageBodyTemplate} showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Porcentaje" sortable></Column>
              <Column field="ACTION" header="Proceso" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Proceso" sortable></Column>
              <Column field="TRHEAD" header="Hilo" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Hilo" sortable></Column>
              <Column field="RECORD" header="Registro" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Registro" sortable></Column>
              <Column field="START" header="Fecha inicio" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Fecha inicio" sortable></Column>
              <Column field="END" header="Fecha fin" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Fecha fin" sortable></Column>
              <Column field="PROCESSED" header="Procesados" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Procesados" sortable></Column>
              <Column field="ERROR" header="Error" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Error" sortable></Column>
            </DataTable>
            {warningRows.length > 0 && <div className="datatable-style-demo flex flex-column justify-content-center align-items-center">

              <DataTable className="text-xs" header={tableHeader2} value={warningRows} first={warningFirst2} rows={warningRows2} onPage={onCustomPage2}
                dataKey="CONTRACT" size="small" paginator paginatorTemplate={template2}
              >
                <Column field="CONTRACT" header="Contrato" showFilterOperator={false}></Column>
                <Column field="OBSERVATION" header="Comentario" showFilterOperator={false}></Column>
              </DataTable>
            </div>}
          </div>
          : null}
    </>
  );

  const headerLN = (
    <div>
      <h3>Liquidación del proceso adicional</h3>
    </div>
  )

  const footerRN = (
    <div>
      <Button label="Generar" loading={loading3} onClick={() => { setLoading3(true); postPayrollReport() }} />
    </div>
  );

  const headerRN = (
    <div>
      <h3>¿Desea generar el reporte de nómina?</h3>
    </div>
  )


  const footerAsociar = (
    <>
      <div>
        <Button label="Cancelar" style={{ marginLeft: "-1rem" }} onClick={() => { hideModalAsociar() }} />
        <Button label="Guardar" loading={loading8} onClick={() => { postAdditionalEmployees() }} disabled={contrato === ""} />
      </div>
      <div className="datatable-style-demo">
        <DataTable className="text-xs" value={rowsAsociar} first={first2Asociar} rows={rows2Asociar} onPage={onCustomPage2}
          paginator paginatorTemplate={template2}
          selection={selectedRowsAsociar} onSelectionChange={(e) => setSelectedRowsAsociar(e.value)} dataKey="ID"
          size="small" filters={filters1Asociar} filterDisplay="menu" globalFilterFields={['CONTRACT_ID', 'NUMBER_ID', 'NAME']}
          rowClassName={rowClassName}
        >
          <Column field="CONTRACT_ID" header="Contrato" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por contrato" sortable></Column>
          <Column field="NUMBER_ID" header="Identificación" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por identificación" sortable></Column>
          <Column field="NAME" header="Nombre" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por nombre" sortable></Column>
          <Column header="Acciones" headerStyle={{ width: '50px', textAlign: 'center' }} bodyStyle={{ textAlign: 'center', overflow: 'visible' }} body={actionBodyTemplateAsociar} />

        </DataTable>
      </div>
    </>
  );

  const headerAsociar = (
    <div>
      <h3>Asociar</h3>
    </div>
  )

  const msgContent = (
    <div>
      <a style={{ fontWeight: 'bold', textDecoration: 'underline', color: '#3b82f6' }}>
        {process.env.REACT_APP_DISABLE_MSG}
      </a>
    </div>
  )

  return (

    <div>
      <Toast ref={toast} />
      <div className="flex flex-row align-items-center justify-content-center mb-3 mt-6 font-bold text-4xl">
        <span className="text-900">Procesos adicionales</span>
        {/* <Video header="Instructivo retiro de empleado" url={localStorage.getItem('SOCIAL_BENEFITS_VIDEO')} /> */}
      </div>

      <ConfBar style={{ marginTop: "-2rem" }} />

      <div className="surface-100	 px-4 py-2 md:px-6 lg:px-8">

        <Dialog header={addHeader} footer={addFooter} visible={isOpen} position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModal}>
          <LabelField htmlFor="label">Calendario</LabelField>
          <Dropdown filter showClear filterBy="DETAIL" style={elementWidth} value={calendario} options={listaCalendario}
            placeholder={"Seleccione un Calendario"} onChange={(e) => setCalendario(e.value)} optionLabel='DETAIL' />
          {/* <LabelField htmlFor="label">Observaciones</LabelField>
          <InputTextarea maxLength={70} value={observacion} onChange={(e) => setObservacion(e.target.value)} rows={4} cols={30} style={elementWidth} disabled={!calendario} /> */}
        </Dialog>

        <Dialog header={deleteHeader} footer={deleteFooter} visible={isOpenEliminar}
          position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalEliminar}>
        </Dialog>

        <Dialog header={headerPB} footer={footerPB} visible={isOpenPlano}
          position="top" style={{ width: "40vw" }} draggable={false} resizable={false} modal onHide={hideModalPlano}>
          <span style={{ fontSize: "0.8rem" }}>Campos obligatorios (*)</span>
          {/* <LabelField htmlFor="label">Calendario liquidación plano bancario *</LabelField>
          <Dropdown style={elementWidth} value={plano}
            filter showClear filterBy="label"
            options={listaPlanoBancario} placeholder={"Seleccione el calendario"}
            onChange={(e) => {
              setPlano(e.value)
            }}
            optionLabel="DETAIL"
          /> */}
          <div>
            <LabelField htmlFor="label">Fecha pago plano bancario *</LabelField>
            <Calendar style={elementWidth} id="navigators" value={fechaPlano}
              onChange={(e) => setFechaPlano(e.value)}
              locale="es" dateFormat="dd-mm-yy" showIcon placeholder={fechaPlano}
              yearRange="2010:2030"
            />
          </div>
        </Dialog>

        <Dialog header={headerLN} footer={footerLN} visible={isOpenLiquidacion} maximizable closable={!loading5 && !loading6 && !loading7}
          position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalLiquidacion}>
          <span style={{ fontSize: "0.8rem" }}>Campos obligatorios (*)</span>
          <LabelField htmlFor="label">Calendario liquidación *</LabelField>
          <div className="p-inputgroup">
            <Dropdown style={elementWidth} value={liquidacion}
              filter showClear filterBy="DETAIL"
              options={listaLiquidacion} placeholder={"Seleccione el calendario"}
              onChange={(e) => {
                setLiquidacion(e.value)
              }}
              optionLabel="DETAIL"
            />
            <Button icon="pi pi-search" loading={loading11} className="mr-2 p-button-sm text-xs" tooltip="Consultar procesos anteriores"
              tooltipOptions={{ position: 'top' }} onClick={() => { setLoading11(true); setWarningTable() }} disabled={!liquidacion || listaLiquidacion.length === 0 || (loading5 || loading6 || loading7)} />
          </div>
        </Dialog>

        <Dialog header={headerRN} footer={footerRN} visible={isOpenRN} bo
          position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalRN} />

        <Dialog header={headerAsociar} footer={footerAsociar} visible={isOpenAsociar}
          position="top" style={{ width: width > 510 ? "46rem" : "26rem" }} draggable={false} resizable={false} modal onHide={hideModalAsociar}>
          <LabelField htmlFor="label">Código empleado</LabelField>
          <Dropdown style={elementWidth} value={contrato}
            filter showClear filterBy="NAME"
            options={listaContratos} placeholder={"Seleccione el empleado"}
            onChange={(e) => {
              setContrato(e.value)
            }}
            optionLabel="NAME"
          />
        </Dialog>

        <Dialog header={deleteHeaderAsociar} footer={deleteFooterAsociar} visible={isOpenEliminarAsociar}
          position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalEliminarAsociar}>
        </Dialog>

        <Dialog header={historicoHeader} footer={hisotricoFooter} visible={isOpenHistorico} bo
          position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalHistorico} />

        <Dialog header={"Errores"} visible={isOpenErrors}
          position="top" style={{ width: "70vw" }} draggable={false} resizable={false} modal onHide={() => setIsOpenErrors(false)}>
          <div className="datatable-style-demo flex flex-column justify-content-center align-items-center">

            <DataTable className="text-xs" value={errorRows} dataKey="CONTRACT_ID">
              <Column field="CONTRACT_ID" header="Contrato" showFilterOperator={false}></Column>
              <Column field="MESSAGE" header="Mensaje" showFilterOperator={false}></Column>
            </DataTable>
          </div>
        </Dialog>

        {localStorage.getItem('additional') === 'N' ?
          <div className='flex justify-content-center'>
            <Card style={{ width: "60%" }}>
              <Message severity="info"
                style={{
                  width: "100%",
                  fontSize: "18px",
                  border: 'solid #696cff',
                  borderWidth: '2px',
                  color: '#696cff'
                }}
                content={msgContent}
              />
            </Card>
          </div>
          :
          <div className="card mt-4">
            <SkeletonTable load={loadPage}>
              <Toolbar className="mb-1" center={centerToolbarTemplate}  ></Toolbar>
              <Toolbar className="mb-1" start={leftToolbarTemplate} ></Toolbar>
              <DataTable className="text-xs" value={rowData} paginator paginatorTemplate={template2} first={first2} rows={rows2} onPage={onCustomPage2}
                scrollHeight="flex" selection={selectedProducts} onSelectionChange={(e) => setSelectedProducts(e.value)} dataKey="ID_ADDITIONAL"
                size="small" filters={filters1} filterDisplay="menu" globalFilterFields={["ID_ADDITIONAL", 'ID_CALENDAR', 'YEAR', 'MONTH', 'DETAIL', 'LAPSE', 'OBSERVATION', 'STATUS']}
                header={header1} >
                <Column selectionMode="single" headerStyle={{ width: '3em' }}></Column>
                <Column field="ID_ADDITIONAL" header="Id" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por id" sortable></Column>
                <Column field="ID_CALENDAR" header="Calendario" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por calendario" sortable></Column>
                <Column field="TOTAL_CONTRACT" header="Número empleados" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por calendario" sortable></Column>
                <Column field="TOTAL_REMUNER" header="Neto" body={netBodyTemplatePlano} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por calendario" sortable></Column>
                <Column field="YEAR" header="Año" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por año" sortable></Column>
                <Column field="MONTH" header="Mes" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por mes" sortable></Column>
                <Column field="DETAIL" header="Período" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por período" sortable></Column>
                <Column field="LAPSE" header="Lapso" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por lapso" sortable></Column>
                <Column field="STATUS" header="Estado" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por estado" sortable></Column>
                {/* <Column field="OBSERVATION" header="Observaciones" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por observación" sortable></Column> */}
                <Column header="Acciones" headerStyle={{ width: '50px', textAlign: 'center' }} bodyStyle={{ textAlign: 'center', overflow: 'visible' }} body={actionBodyTemplate} />
              </DataTable>
            </SkeletonTable>
          </div>}

      </div>

    </div>
  );
}